export enum NonAuthRedirectPath {
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
}
